import React, { useEffect, useState } from 'react'
import { List, Box, Text } from 'grommet'
import { useSelector, useDispatch } from 'react-redux'
import { ActionCreators, Selectors } from 'galarm-shared'
import { Constants, I18n, colorThemes } from 'galarm-config'
import UnifiedAlarmSummary from './UnifiedAlarmSummary'
import SearchBar from './SearchBar'
import { Fab } from 'react-tiny-fab'
import { Add } from 'grommet-icons'

const { instantAlarmsSelector } = Selectors

const InstantAlarmList = ({ showSearchBar, hideSearchBar }) => {
  const [searchText, setSearchText] = useState('')
  const dispatch = useDispatch()
  const colorScheme = useSelector(state => state.userSettings.webColorScheme)

  useEffect(() => {
    if (!showSearchBar) {
      setSearchText('')
    }
  }, [showSearchBar])

  const instantAlarms = useSelector(instantAlarmsSelector)

  const filteredAlarms = instantAlarms.filter(alarm =>
    alarm.name.toLowerCase().includes(searchText.toLowerCase())
  )

  const sentAlarms = filteredAlarms.filter(
    alarm => alarm.alarmCategory === Constants.AlarmCategories.MY_ALARM
  )
  const receivedAlarms = filteredAlarms.filter(
    alarm => alarm.alarmCategory === Constants.AlarmCategories.PARTICIPANT_ALARM
  )

  const listData = []
  if (sentAlarms.length > 0) {
    listData.push({ sectionName: I18n.t('sent') })
    listData.push(...sentAlarms)
  }
  if (receivedAlarms.length > 0) {
    listData.push({ sectionName: I18n.t('received') })
    listData.push(...receivedAlarms)
  }

  const onNewInstantAlarm = () => {
    dispatch(ActionCreators.showNewInstantAlarmWizard({}))
  }

  return (
    <Box flex overflow="auto" style={{ paddingBottom: '70px' }}>
      {showSearchBar && (
        <SearchBar
          onChangeText={setSearchText}
          searchText={searchText}
          onCloseSearchBar={hideSearchBar}
          focus
        />
      )}
      {listData.length === 0 ? (
        <Box pad="medium" flex justify="center" align="center">
          <Text color="textColor" style={{ whiteSpace: 'pre-line' }}>
            {I18n.t('noInstantAlarms')}
          </Text>
        </Box>
      ) : (
        <List
          border={false}
          margin={{ vertical: 'small' }}
          pad={{ vertical: 'xsmall', horizontal: 'small' }}
          data={listData}
          // eslint-disable-next-line react/no-children-prop
          children={UnifiedAlarmSummary}
        />
      )}
      <Fab
        mainButtonStyles={{
          backgroundColor: colorThemes.getColorTheme(colorScheme).primary
        }}
        style={{
          bottom: 0,
          left: 0
        }}
        icon={<Add color="white" />}
        event="hover"
        onClick={onNewInstantAlarm}
        text={I18n.t('newInstantAlarm')}
      />
    </Box>
  )
}

export default InstantAlarmList
